import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  FormGroup,
  Label,
  CardFooter,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";

import {
  ProductQualitiesAdd,
  ProductQualitySelecteChangeValue,
  modelClose,
  apiError,
  getProductQualitiesRowData,
  modelOpen,
} from "../../../store/Masters/ProductQuality/action";

import {
  getMiniQUALITY,
  getMiniProductList,
} from "../../../store/Mini/actions";

import "./ProductQuality.scss";

class AddProductsQuality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bymodel: false,
      id: 0,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      bymodel: this.props.CPmodel ? true : false,
    });
    this.props.apiError();
    this.props.getMiniProductList();
    this.props.getMiniQUALITY();

    let id = 0;
    if (this.props.CPmodel) id = this.props.openId;
    else id = this.props.match.params.id;
    if (id && id !== 0 && id !== "0") {
      this.setState({ id: parseInt(id) });
      this.props.getProductQualitiesRowData(id, this.props.history);
    }
  }

  handleValidSubmit() {
    const data = this.props.rowdata;

    // Validate product and qualities
    if (!data.product_id) {
      Swal.fire({ icon: "error", title: "Please select a product!" });
      return;
    }
    if (!data.quality_ids || data.quality_ids.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Please select at least one quality!",
      });
      return;
    }

    this.props.ProductQualitiesAdd(data, this.state.id, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={!this.state.bymodel ? "page-content" : ""}>
          <Container fluid>
            <Card>
              <AvForm
                className="form-horizontal"
                onValidSubmit={this.handleValidSubmit}
              >
                <CardHeader className="bg-transparent border-bottom">
                  {!this.state.bymodel && (
                    <Link to="/product/quality">
                      <i className="ri-arrow-go-back-fill font-size-18"></i>
                    </Link>
                  )}
                  <CardHeader className="bg-transparent border-bottom">
                    {!this.state.bymodel && <Link to="/product/quality"></Link>}
                    <h5 className="card-title-18 d-inline-block ml-2">
                      {this.state.id
                        ? "Update Product Quality"
                        : "Add Product Quality"}
                    </h5>
                  </CardHeader>
                </CardHeader>

                <CardBody>
                  <Row className="justify-content-center">
                    <Col md={8}>
                      <CardHeader className="bg-transparent border-bottom">
                        <h3 className="card-title-15">
                          Product Quality Details
                        </h3>
                      </CardHeader>

                      <CardBody>
                        <Row>
                          {/* Product Dropdown */}
                          <Col md={6}>
                            <FormGroup>
                              <Label>Select Product</Label>
                              <Select
                                classNamePrefix="select2-selection"
                                options={
                                  Array.isArray(
                                    this.props.miniProductList?.results
                                  )
                                    ? this.props.miniProductList.results.map(
                                        (item) => ({
                                          label: item.name,
                                          value: item.id,
                                        })
                                      )
                                    : []
                                }
                                onInputChange={(inputValue, { action }) => {
                                  if (action === "input-change") {
                                    this.props.getMiniProductList({
                                      ...this.props.miniProductParams,
                                      page: 1,
                                      page_size: 10,
                                      search: inputValue,
                                    });
                                  }
                                }}
                                onMenuOpen={() => {
                                  this.props.getMiniProductList({
                                    ...this.props.miniProductParams,
                                    page: 1,
                                    page_size: 10,
                                    search: "",
                                  });
                                }}
                                onMenuScrollToBottom={() => {
                                  if (
                                    this.props.miniProductParams.page <
                                    this.props.miniProductParams.no_of_pages
                                  ) {
                                    this.props.getMiniProductList({
                                      ...this.props.miniProductParams,
                                      page:
                                        this.props.miniProductParams.page + 1,
                                      page_size: 10,
                                    });
                                  }
                                }}
                                value={
                                  this.props.rowdata?.product_id
                                    ? {
                                        label: this.props.rowdata.productLabel,
                                        value: this.props.rowdata.product_id,
                                      }
                                    : null
                                }
                                onChange={(e) =>
                                  this.props.ProductQualitySelecteChangeValue({
                                    key: "productLabel",
                                    label: e?.label,
                                    key2: "product_id",
                                    value: e?.value,
                                  })
                                }
                              />
                              <Label className="text-danger m-0">
                                {this.props.error_msg?.product_id}
                              </Label>
                            </FormGroup>
                          </Col>

                          <Col md={6}>
                            <FormGroup>
                              <Label>Select Qualities</Label>
                              <Select
                                isMulti
                                classNamePrefix="select2-selection"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                options={
                                  Array.isArray(this.props.qualitylist?.results)
                                    ? this.props.qualitylist.results.map(
                                        (item) => ({
                                          label: item.name,
                                          value: item.id,
                                        })
                                      )
                                    : []
                                }
                                value={
                                  Array.isArray(this.props.rowdata?.quality_ids)
                                    ? this.props.rowdata.quality_ids
                                        .map((id) => {
                                          const q = (
                                            this.props.qualitylist?.results ??
                                            []
                                          ).find((x) => x.id === id);
                                          return q
                                            ? {
                                                label: q.name,
                                                value: q.id,
                                              }
                                            : null;
                                        })
                                        .filter(Boolean)
                                    : []
                                }
                                onChange={(values) => {
                                  this.props.ProductQualitySelecteChangeValue({
                                    key: "qualityLabel",
                                    label: values.map((v) => v.label),
                                    key2: "quality_ids",
                                    value: values.map((v) => v.value),
                                  });
                                }}
                                // ✅ fetch more pages as user scrolls
                                onMenuScrollToBottom={() => {
                                  const { qualityParams } = this.props;
                                  if (
                                    qualityParams.page <
                                    qualityParams.no_of_pages
                                  ) {
                                    this.props.getMiniQUALITY({
                                      ...qualityParams,
                                      page: qualityParams.page + 1,
                                      page_size: 10,
                                    });
                                  }
                                }}
                                // ✅ initial fetch when opened
                                onMenuOpen={() => {
                                  this.props.getMiniQUALITY({
                                    ...this.props.qualityParams,
                                    page: 1,
                                    page_size: 10,
                                    search: "",
                                  });
                                }}
                                // ✅ handle typing for search
                                onInputChange={(inputValue, { action }) => {
                                  if (action === "input-change") {
                                    this.props.getMiniQUALITY({
                                      ...this.props.qualityParams,
                                      page: 1,
                                      page_size: 10,
                                      search: inputValue,
                                    });
                                  }
                                }}
                              />

                              <Label className="text-danger m-0">
                                {this.props.error_msg?.quality_ids}
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>

                        <CardFooter className="bg-transparent pt-3">
                          <div className="float-right">
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-2"
                            >
                              Save
                            </Button>
                            {this.state.bymodel ? (
                              <Button
                                type="button"
                                color="light"
                                onClick={this.props.Close}
                              >
                                Cancel
                              </Button>
                            ) : (
                              <Button
                                type="button"
                                color="light"
                                href="/product/quality"
                              >
                                Cancel
                              </Button>
                            )}
                          </div>
                        </CardFooter>
                      </CardBody>
                    </Col>
                  </Row>
                </CardBody>
              </AvForm>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { miniProductList, miniProductParams, qualitylist, qualityParams } =
    state.Mini;
  const { error_msg, rowdata, model } = state.qualityProduct;
  return {
    miniProductList,
    miniProductParams,
    qualitylist,
    qualityParams,
    error_msg,
    rowdata,
    model,
  };
};

export default connect(mapStateToProps, {
  modelClose,
  apiError,
  getMiniQUALITY,
  getMiniProductList,
  ProductQualitiesAdd,
  ProductQualitySelecteChangeValue,
  getProductQualitiesRowData,
})(AddProductsQuality);
